import styled from 'styled-components';
import { THEME } from '../../../../../../themes';
import { HeadlineFont, Title3Font  } from '../../../../../../themes/fonts';

export const Role = styled.div<{isSingleRole?: boolean}>`
  ${({ isSingleRole }) => isSingleRole ? Title3Font : HeadlineFont};
  font-weight: ${({ isSingleRole }) => isSingleRole ? '600' : '500'};
  color: ${THEME.COLORS.CONTENT_PRIMARY};
`;
